import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskFeedbackRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-feedback',
	path: '/jira/servicedesk/projects/:projectKey/settings/feedback-settings',
};
